export default __webpack_public_path__ + "static/media/search-icon.c522b768.svg";